import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Working Hours\n          ")
], -1);
const _hoisted_4 = { class: "my-2" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 italic" }, "\n              * If you are not uploading a complex shift pattern, please make sure all of the below inputs have been filled out. If an employee will not be working a specific day, please select \"off\".\n            ", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 italic" }, [
        /*#__PURE__*/ _createTextVNode("\n                * If there is a complex work pattern for this role please update the matrix "),
        /*#__PURE__*/ _createElementVNode("a", {
            href: "https://equans.sharepoint.com/:x:/r/sites/ukbuems/_layouts/15/Doc.aspx?sourcedoc=%7B2479141E-51B8-4E48-8467-32167E8BD5C8%7D&file=Shift%20Rotation%20Template.xlsm&action=default&mobileredirect=true",
            target: "_blank",
            class: "text-blue-600 hover:underline"
        }, "here"),
        /*#__PURE__*/ _createTextVNode(" and attach it to this offer form.\n              ")
    ]),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 italic" }, "\n                * If the time Interval you require isn't available above, please provide additional comments at the end of the form.\n              ")
], -1);
const _hoisted_7 = { class: "my-4" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", null, "Upload complex shift pattern:", -1);
const _hoisted_9 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n                Is the employee a shift worker? *\n              ", -1);
const _hoisted_11 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_12 = { class: "mt-4 space-y-4" };
const _hoisted_13 = { class: "flex items-start" };
const _hoisted_14 = { class: "h-5 flex items-center" };
const _hoisted_15 = ["checked", "disabled"];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shiftWorker",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1);
const _hoisted_17 = { class: "flex items-start" };
const _hoisted_18 = { class: "h-5 flex items-center" };
const _hoisted_19 = ["checked", "disabled"];
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "shiftWorker",
        class: "font-medium text-gray-700"
    }, "No")
], -1);
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { class: "col-span-6 mt-4" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approvedWeeklyHours",
    class: "block text-sm font-medium text-gray-700"
}, "Number of shifts in a shift pattern (i.e. 4, if they will be working 4 on and 4 off) *", -1);
const _hoisted_24 = ["value", "disabled"];
const _hoisted_25 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_26 = { class: "col-span-6 mt-4" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approvedWeeklyHours",
    class: "block text-sm font-medium text-gray-700"
}, "Number of days in a shift pattern (i.e. 8, if they will be working 4 on and 4 off) *", -1);
const _hoisted_28 = ["value", "disabled"];
const _hoisted_29 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("p", { class: "italic" }, "\n              * Shift calculation is based on: Number of shifts in a shift pattern divided by te number of days in a shift pattern (including non working days)\n              multiplied by 7 by a Government Leave Factor.\n            ", -1);
const _hoisted_31 = { class: "col-span-6 mt-4" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approvedWeeklyHours",
    class: "block text-sm font-medium text-gray-700"
}, "Number of shifts per annum: *", -1);
const _hoisted_33 = ["value", "disabled"];
const _hoisted_34 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("p", null, "* As the employee is a shift worker we need to note the number of shifts per annum.", -1);
const _hoisted_36 = { class: "col-span-6 mt-4" };
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("label", {
    for: "fullTimeHours",
    class: "block text-sm font-medium text-gray-700"
}, "How many hours would be worked by a full time employee in this role? (per week) *", -1);
const _hoisted_38 = ["value", "disabled"];
const _hoisted_39 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_40 = { class: "col-span-6 mt-4" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("label", {
    for: "approvedWeeklyHours",
    class: "block text-sm font-medium text-gray-700"
}, "Approved weekly working hours for this contract:", -1);
const _hoisted_42 = ["value"];
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 italic" }, "\n            * The proposed weekly working hours total must match the Monday to Friday hours shown above, otherwise\n            the contract will be delayed.\n          ", -1);
const _hoisted_44 = { class: "col-span-6 mt-4" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", {
    for: "weeksPerYear",
    class: "block text-sm font-medium text-gray-700"
}, "How many weeks will be worked per year?", -1);
const _hoisted_46 = ["value"];
const _hoisted_47 = { class: "col-span-6 mt-4" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("label", {
    for: "proposedWeeklyHours",
    class: "block text-sm font-medium text-gray-700"
}, "Proposed weekly working hours for this contract: *", -1);
const _hoisted_49 = ["value", "disabled"];
const _hoisted_50 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_51 = {
    key: 1,
    class: "text-red-600 italic"
};
const _hoisted_52 = {
    key: 0,
    class: "p-3 w-full flex flex-row items-center"
};
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 ml-2" }, "\n            Once submitted, this document will go for re-approval because the terms have changed.\n          ", -1);
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("p", { class: "text-md text-red-600 italic" }, "* Please complete the full work pattern schedule or upload complex work pattern to proceed", -1);
const _hoisted_55 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_56 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_WorkingWeek = _resolveComponent("WorkingWeek");
    const _component_FileUploader = _resolveComponent("FileUploader");
    const _component_ExclamationIcon = _resolveComponent("ExclamationIcon");
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(),
                        _createVNode(_component_WorkingWeek, {
                            data: _ctx.model.workingWeek,
                            "disable-form": _ctx.disableForm,
                            onUpdate: _ctx.handleUpdateWorkingHours,
                            onMarkComplete: _ctx.handleMarkComplete
                        }, null, 8, ["data", "disable-form", "onUpdate", "onMarkComplete"]),
                        _createTextVNode(),
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createTextVNode(),
                            _createVNode(_component_FileUploader, {
                                name: "complex-shift-pattern",
                                "document-short-id": _ctx.formData?.shortId,
                                files: _ctx.formData?.files,
                                disabled: _ctx.disableForm,
                                uploading: _ctx.uploading,
                                onUpdateFiles: _ctx.handleUpdateFiles,
                                onFileUploading: _cache[0] || (_cache[0] = ($event) => (_ctx.uploading = $event))
                            }, null, 8, ["document-short-id", "files", "disabled", "uploading", "onUpdateFiles"])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_10,
                            _createTextVNode(),
                            (_ctx.v$.formData.shiftWorker.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "\n                * " + _toDisplayString(_ctx.v$.formData.shiftWorker.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("input", {
                                                id: "shiftWorker-yes",
                                                value: "Yes",
                                                name: "shiftWorker",
                                                type: "radio",
                                                class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                checked: _ctx.formData?.shiftWorker === 'Yes',
                                                disabled: _ctx.disableForm,
                                                onChange: _cache[1] || (_cache[1] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                                onBlur: _cache[2] || (_cache[2] = ($event) => (_ctx.v$.formData.shiftWorker.$touch()))
                                            }, null, 40, _hoisted_15)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_16
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("input", {
                                                id: "shiftWorker-no",
                                                value: "No",
                                                name: "shiftWorker",
                                                type: "radio",
                                                class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                checked: _ctx.formData?.shiftWorker === 'No',
                                                disabled: _ctx.disableForm,
                                                onChange: _cache[3] || (_cache[3] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                                onBlur: _cache[4] || (_cache[4] = ($event) => (_ctx.v$.formData.shiftWorker.$touch()))
                                            }, null, 40, _hoisted_19)
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_20
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData?.shiftWorker === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "numberOfShiftsPerPattern-input",
                                    value: _ctx.formData?.numberOfShiftsPerPattern,
                                    type: "text",
                                    name: "numberOfShiftsPerPattern",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[5] || (_cache[5] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[6] || (_cache[6] = ($event) => (_ctx.v$.formData.numberOfShiftsPerPattern.$touch()))
                                }, null, 40, _hoisted_24),
                                _createTextVNode(),
                                (_ctx.v$.formData.numberOfShiftsPerPattern.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "\n                * " + _toDisplayString(_ctx.v$.formData.numberOfShiftsPerPattern.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "numberOfDaysPerPattern-input",
                                    value: _ctx.formData?.numberOfDaysPerPattern,
                                    type: "number",
                                    min: "0",
                                    name: "numberOfDaysPerPattern",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.v$.formData.numberOfDaysPerPattern.$touch()))
                                }, null, 40, _hoisted_28),
                                _createTextVNode(),
                                (_ctx.v$.formData.numberOfDaysPerPattern.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "\n                * " + _toDisplayString(_ctx.v$.formData.numberOfDaysPerPattern.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _hoisted_30,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "shiftsPerAnnum-input",
                                    value: _ctx.formData?.shiftsPerAnnum,
                                    type: "number",
                                    name: "shiftsPerAnnum",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[9] || (_cache[9] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.v$.formData.shiftsPerAnnum.$touch()))
                                }, null, 40, _hoisted_33),
                                _createTextVNode(),
                                (_ctx.v$.formData.shiftsPerAnnum.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "\n                * " + _toDisplayString(_ctx.v$.formData.shiftsPerAnnum.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _hoisted_35
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "fullTimeHours-input",
                            value: _ctx.formData?.fullTimeHours,
                            type: "text",
                            name: "fullTimeHours",
                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[11] || (_cache[11] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[12] || (_cache[12] = ($event) => (_ctx.v$.formData.fullTimeHours.$touch()))
                        }, null, 42, _hoisted_38),
                        _createTextVNode(),
                        (_ctx.v$.formData.fullTimeHours.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, "\n              * " + _toDisplayString(_ctx.v$.formData.fullTimeHours.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "approvedWeeklyHours-input",
                            value: _ctx.formData?.approvedWeeklyHours,
                            type: "number",
                            min: "0",
                            name: "approvedWeeklyHours",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                            disabled: "",
                            onInput: _cache[13] || (_cache[13] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                        }, null, 40, _hoisted_42)
                    ]),
                    _createTextVNode(),
                    _hoisted_43,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "weeksPerYear-input",
                            value: _ctx.formData?.weeksPerYear ?? _ctx.atr?.formFive.weeksPerYear,
                            type: "number",
                            name: "weeksPerYear",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                            disabled: "",
                            onInput: _cache[14] || (_cache[14] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                        }, null, 40, _hoisted_46)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "proposedWeeklyHours-input",
                            value: _ctx.formData?.proposedWeeklyHours,
                            type: "number",
                            min: "0",
                            name: "proposedWeeklyHours",
                            class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                            disabled: _ctx.disableForm,
                            onInput: _cache[15] || (_cache[15] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[16] || (_cache[16] = ($event) => (_ctx.v$.formData.proposedWeeklyHours.$touch()))
                        }, null, 42, _hoisted_49),
                        _createTextVNode(),
                        (_ctx.v$.formData.proposedWeeklyHours.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, "\n              * " + _toDisplayString(_ctx.v$.formData.proposedWeeklyHours.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    (_ctx.formData?.proposedWeeklyHours !== _ctx.formData?.approvedWeeklyHours)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_51, "\n            * Any differences between Approved and Proposed weekly working hours will result in first and second line re-approval\n          "))
                        : _createCommentVNode("", true)
                ]),
                _createTextVNode(),
                (_ctx.hasChanged)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createVNode(_component_ExclamationIcon, { class: "text-red-600 h-16 w-16" }),
                        _createTextVNode(),
                        _hoisted_53
                    ]))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                _hoisted_54
            ]),
            _createTextVNode(),
            (_ctx.editable || _ctx.document.currentStageName === 'offer.notifyPrepOffer')
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid || !_ctx.shiftPatternPresent || _ctx.uploading,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[17] || (_cache[17] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_56)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
